export default __webpack_public_path__ + "static/media/102_mobile.d9d94146.jpg";